module.exports = "https://cdn.hellotech.com/client-assets/Nest_3c41c6fd33eb5bc555473ecb1d57cacc.png";